export enum FEATURE_FLAGS {
  BUNDLE_ENABLED = 'smart-shopping-bundle-enabled',
}

export enum RECOMMENDATION_ENGINES {
  SIMILARITY_ML_V2 = 'SimilarityML_v2',
  FREQUENTLY_BOUGHT_TOGETHER = 'FrequentlyBoughtTogether',
  BUNDLE = 'Bundle',
  PRODUCT_COMPARATOR = 'ProductComparator_v1',
}
